var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import dayjs from 'dayjs';
export function cleanProps(props) {
    var time = props.time, rest = __rest(props, ["time"]);
    var inputProps = rest;
    if (typeof inputProps.selectAllOnFocus === 'undefined')
        inputProps.selectAllOnFocus = true;
    return inputProps;
}
export function getDate(date) {
    date = dayjs(date || null);
    if (date.isValid())
        return date;
}
export function getDateFromItems(time, day, month, year, hour, minute) {
    if (!day || !month || !year) {
        return null;
    }
    if (time) {
        var dateStr = "".concat(getRealValue(year, 'y'), "-").concat(getRealValue(month, 'm'), "-").concat(getRealValue(day, 'd'), " ").concat(getRealValue(hour || 0, 'h'), ":").concat(getRealValue(minute || 0, 'm'));
        var date = dayjs(dateStr, 'YYYY-MM-DD HH:mm', true);
        if (date.isValid() && date.year() >= 1970 && date.year() <= 2100)
            return date;
    }
    else {
        var dateStr = "".concat(getRealValue(year, 'y'), "-").concat(getRealValue(month, 'm'), "-").concat(getRealValue(day, 'd'));
        var date = dayjs(dateStr, 'YYYY-MM-DD', true);
        if (date.isValid() && date.year() >= 1970 && date.year() <= 2100)
            return date;
    }
}
export function getFormated(date) {
    date = getDate(date);
    if (date) {
        return {
            date: date,
            d: date.get('date').toString().padStart(2, '0'),
            m: (date.get('month') + 1).toString().padStart(2, '0'),
            y: date.get('year').toString(),
            h: date.get('hour').toString().padStart(2, '0'),
            i: date.get('minute').toString().padStart(2, '0'),
        };
    }
}
function getRealValue(value, input) {
    value = Number(value);
    if (!value.isNan()) {
        switch (input) {
            case 'd':
                return value.toString().padStart(2, '0');
            case 'm':
                return value.toString().padStart(2, '0');
            case 'y':
                return value.toString();
            case 'h':
                return value.toString().padStart(2, '0');
            case 'i':
                return value.toString().padStart(2, '0');
        }
    }
    return '';
}
export function isSame(date1, date2) {
    if (date1 === date2) {
        return false;
    }
    date1 = getDate(date1);
    date2 = getDate(date2);
    if (!date1 && !date2) {
        return false;
    }
    else if (date1 && date2) {
        if (date1.isSame(date2, 'date')) {
            return false;
        }
        else {
            return true;
        }
    }
    return true;
}
export function isErrored(time, input, value, day, month, year, hour, minute) {
    value = Number(value);
    if (!value.isNan() && value > 0) {
        if (input === 'd') {
            if (month && year) {
                return true;
            }
        }
        else if (input === 'm') {
            if (day && year) {
                return true;
            }
        }
        else if (input === 'y') {
            if (day && month) {
                return true;
            }
        }
    }
    return false;
}
